export default {
    computed: {
      gstNumberError() {
        const gstField = this.$v.gstNumber;
        if (!gstField.$error) return '';
        if (!gstField.required) return 'GST number is required';
        if (!gstField.validGST) return 'Please enter valid GST Number';
        return '';
      },
      amountError() {
        const field = this.$v.amount;
        if (!field.$error) return '';
        if (!field.required) return 'Amount is required';
        if (!field.numeric) return 'Amount must be a number';
        if (!field.nonZeroAmount) return 'Amount should be greater than 0';
        return '';
      },
    },
  };
  